import moment from 'moment'

const localeLanguage = (window.navigator as any).userLanguage || window.navigator.language;
const isLocalEN = (locale: string) => locale && locale.substring(0, 2).toLowerCase() === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
moment.defineLocale(localeLanguage as any, {
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: isLocalEN(localeLanguage),
        LL: 'D MMMM YYYY',
        LLL: `${isLocalEN(localeLanguage)} - hh:mm A`,
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: 'a few seconds',
        ss: '%d s',
        m: "a m",
        mm: "%d m",
        h: "an h",
        hh: "%d h",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }
});
